import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Account, Board, Card } from "../../../backend/backendapi";
import { KanbanState } from "../../kanban.model";
import BoardSelect from "./boardselect/boardselect.controller";

@Component({
    name: 'ShareCardModal',
    components: {
        BoardSelect: require('./boardselect/boardselect.vue.html').default,
    }
})
export default class ShareCardModal extends Vue {
    @Prop({ required: true })
    modalId!: string;
    @Prop({ required: true })
    state!: KanbanState;
    @Prop({ required: true })
    card!: Card;
    @Prop({ required: true })
    sharedWith!: number[];

    private selectedBoard: Board | null = null;
    private selfShareAccount?: Account;

    private get available(): Account[] {
        let ex = this.sharedWith.map(e => e);
        return this.flattendAccounts.filter(e => !ex.includes(e.accountId!));
    }

    private get alreadySharedWith(): Account[] {
        let incl = this.sharedWith.map(e => e);
        return this.flattendAccounts.filter(e => incl.includes(e.accountId!));
    }

    private get flattendAccounts(): Account[] {
        return this.state.accounts?.parentList?.filter(e => e.account).map(e => e.account!) ?? [];
    }

    private close(): void {

    }

    private add(account: Account): void {
        if (account.accountId! === this.state.accounts!.selectedItem!) {
            this.selfShareAccount = account;
            (this.$refs.boardselect as BoardSelect).openModal();
        } else {
            this.$emit('addCardShared', { account: account, card: this.card });
        }
    }

    private remove(account: Account): void {
        this.$emit('removeCardShared', { account: account, card: this.card });
    }

    private selfShardBoardSelected(board: Board): void {
        if (board.id! === 0) {//inbox
            this.$emit('addCardShared', { account: this.selfShareAccount!, card: this.card });
        } else {
            this.$emit('addCardShared', { account: this.selfShareAccount!, card: this.card, board: board });
        }
    }
}